<template>
    <div aria-live="polite" aria-atomic="true" style="position: relative;">
        <div class="toast notification-toast w-100 d-flex flex-column p-2" role="alert" aria-live="assertive" aria-atomic="true" data-autohide="false">
            <div class="toast-header">
                <i class="fas mr-2" :class="getNotificationIcon(notificationDetails)"></i>
                <strong v-html="notificationDetails.title" class="mr-auto"></strong>&nbsp;
                <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close" @click="closeBubble()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="toast-body text-t_blue">
                <span v-html="notificationDetails.text"></span>
                <button class="btn btn-actionable float-right p-1 pl-2 pr-2" @click="openNotificationTarget(notificationDetails)">
                    <i class="fas fa-arrow-right"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapState('login', ['userLoggedIn']),
        ...mapState('notifications', ['showNotificationBubble', 'notificationDetails']),
        ...mapGetters('login', ['getAccountType']),
        ...mapGetters('offers', ['getLiveContracts', 'getHasExistingContracts']),
    },
    methods: {
        ...mapActions('conversation', ['loadConversation']),
        ...mapActions('notifications', ['popNotification','updateNotification']),
          ...mapActions('offers', ['getLiveContractsList']),
        closeBubble: function(){
            $('.notification-toast').toast('hide')
            setTimeout(() => {
                this.popNotification(false)
            }, 500)
        },
        openNotificationTarget: function(notificationObject){
            let notificationGroupId = ''

            /* To open a new message */
            if (notificationObject.type == 'message_alert'){
                this.goToOlfChat(notificationObject.conversationId)
                notificationGroupId = notificationObject.conversationId
            }
            /* To go to order history */
            else if (notificationObject.type == 'order_placed_alert'){
                this.goToOrderHistory()
                notificationGroupId = notificationObject.orderId;
            } else if(notificationObject.type === 'buyer_activated'){
                this.$router.push('/AllPrices/ex-rack');
            }
            this.updateNotification(notificationGroupId);
            this.closeBubble()
        },
        goToOlfChat: function(conversationId){
            /* Go to the page */
            this.$router.push({name: 'OlfChat'})

            /* Select and load the conversation */
            this.loadConversation(conversationId)
        },
        goToOrderHistory: function(){
            this.$router.push("/OrderHistory");
        },
getNotificationIcon: function(notificationDetails){
            const fa_calendar_check = "fa-calendar-check p-2";	
            const fa_chart_line = "fa-chart-line p-2";	
            const fa_comments = "fa-comments p-2";	
            const fa_users = "fa-users pt-2 pb-2 pl-1 pr-1";	
            switch (notificationDetails.type){	 
                case 'message_alert':	            
                    return fa_comments;
                case 'order_placed_alert':
                    return fa_calendar_check;
                case 'buyer_activated':
                    return fa_users;
                default:
                    return fa_chart_line;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.toast.notification-toast {
    position: absolute; 
    top: 0; 
    right: 0.5rem;
    z-index: 3;
    border-radius: 0.8rem;
    background-color: map-get($platform-theme, toast-notification-bg-color);

    .toast-header .fas {
        border-radius: 50%;
        background-color: map-get($platform-theme, toast-notification-image-bg-color);
        color: map-get($platform-theme, toast-notification-image-color);
        font-size: 1.5rem;
    }

    .btn-actionable {
        border-radius: 50%;
        max-width: 30px!important;
    }

    .toast-body {
        color: map-get($platform-theme, toast-notification-text-color);
    }
}
</style>
